/** Blur whatever element currently holds focus. Used to release table-wrapper /
 *  input focus before a canvas interaction so a component's keydown `stopPropagation`
 *  (e.g. the table's Delete/Backspace handling) doesn't swallow the next key. */
export function blurActiveElement(): void {
  (document.activeElement as HTMLElement | null)?.blur();
}
